<template>
    <div class="rich-text-editor">
        <ckeditor v-model="body" :config="$options.editorConfig" :editor-url="$options.editorUrl" />
    </div>
</template>

<script>
import CKEditor from 'ckeditor4-vue';

export default {
    components: {
        ckeditor: CKEditor.component,
    },
    props: {
        value: String,
    },
    data() {
        return {
            body: this.value,
        };
    },
    watch: {
        body() {
            this.$emit('input', this.body);
        },
    },
    // created() {
    //     console.debug(CKEditor);
    // },
    editorUrl: '/js/ckeditor/ckeditor.js',
    editorConfig: {
        on: {
            fileUploadRequest(evt) {
                let xhr = evt.data.fileLoader.xhr;
                xhr.setRequestHeader('X-CSRF-TOKEN', document.querySelector('meta[name="csrf-token"]').getAttribute('body'));
                xhr.setRequestHeader('Authorization', 'Bearer ' + api_token);
            },
        },
        extraPlugins: 'font',
        // must have at least one query string variable so when the "&baz=qux" is added it still works
        filebrowserImageUploadUrl: '/api/rte-images?foo=bar',
        toolbarGroups: [
            { name: 'clipboard',   groups: [ 'clipboard', 'undo' ] },
            { name: 'editing',     groups: [ 'find', 'selection', 'spellchecker' ] },
            { name: 'links' },
            { name: 'insert' },
            { name: 'forms' },
            { name: 'tools' },
            { name: 'document',	   groups: [ 'mode', 'document', 'doctools' ] },
            { name: 'others' },
            '/',
            { name: 'basicstyles', groups: [ 'basicstyles', 'cleanup' ] },
            { name: 'paragraph',   groups: [ 'list', 'indent', 'blocks', 'align', 'bidi' ] },
            // { name: 'styles' },
            // { name: 'styles', items: [ 'Font', 'FontSize' ] },
            { name: 'styles', groups: [ 'font', 'fontsize' ] },
            { name: 'colors' },
            // { name: 'about' }
        ],
        removeButtons: 'Subscript,Superscript,Styles',
        format_tags: 'p;h1;h2;h3;pre',
        removeDialogTabs: 'image:advanced;link:advanced',
        allowedContent: true,
        contentsCss: '/css/rte.css',
        // extraPlugins: 'image2',
        // stylesSet: [
        //     { name: 'Expandable', element: 'div', 'attributes': { 'class': 'expandable'} },
        // ],
        // font_names: 'Calibri',
    },

    created() {
        console.debug('rte created');
    },
}
</script>

<style lang="scss">
</style>
